import { Outlet } from "react-router-dom";
import Sidenav1 from "../Component/sidenav";
import Header from "../Component/Header";

export default function Layout() {
  return (
    <div className="app-layout">
      <Sidenav1 />

      <div className="main-content">
        <Header />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
